module.exports = __webpack_public_path__ + "img/greytick.f32d1bae.svg";